<template>
  <!-- viewBox="0 0 16 16" -->
  <path
    d="M3.25 11.5C3.94036 11.5 4.5 12.0596 4.5 12.75C4.5 13.4404 3.94036 14 3.25 14C2.55964 14 2 13.4404 2 12.75C2 12.0596 2.55964 11.5 3.25 11.5Z"
    fill="currentColor"
  />
  <path
    d="M8 11.5C8.69036 11.5 9.25 12.0596 9.25 12.75C9.25 13.4404 8.69036 14 8 14C7.30964 14 6.75 13.4404 6.75 12.75C6.75 12.0596 7.30964 11.5 8 11.5Z"
    fill="currentColor"
  />
  <path
    d="M12.75 11.5C13.4404 11.5 14 12.0596 14 12.75C14 13.4404 13.4404 14 12.75 14C12.0596 14 11.5 13.4404 11.5 12.75C11.5 12.0596 12.0596 11.5 12.75 11.5Z"
    fill="currentColor"
  />
  <path
    d="M3.25 6.75C3.94036 6.75 4.5 7.30964 4.5 8C4.5 8.69036 3.94036 9.25 3.25 9.25C2.55964 9.25 2 8.69036 2 8C2 7.30964 2.55964 6.75 3.25 6.75Z"
    fill="currentColor"
  />
  <path
    d="M8 6.75C8.69036 6.75 9.25 7.30964 9.25 8C9.25 8.69036 8.69036 9.25 8 9.25C7.30964 9.25 6.75 8.69036 6.75 8C6.75 7.30964 7.30964 6.75 8 6.75Z"
    fill="currentColor"
  />
  <path
    d="M12.75 6.75C13.4404 6.75 14 7.30964 14 8C14 8.69036 13.4404 9.25 12.75 9.25C12.0596 9.25 11.5 8.69036 11.5 8C11.5 7.30964 12.0596 6.75 12.75 6.75Z"
    fill="currentColor"
  />
  <path
    d="M3.25 2C3.94036 2 4.5 2.55964 4.5 3.25C4.5 3.94036 3.94036 4.5 3.25 4.5C2.55964 4.5 2 3.94036 2 3.25C2 2.55964 2.55964 2 3.25 2Z"
    fill="currentColor"
  />
  <path
    d="M8 2C8.69036 2 9.25 2.55964 9.25 3.25C9.25 3.94036 8.69036 4.5 8 4.5C7.30964 4.5 6.75 3.94036 6.75 3.25C6.75 2.55964 7.30964 2 8 2Z"
    fill="currentColor"
  />
  <path
    d="M12.75 2C13.4404 2 14 2.55964 14 3.25C14 3.94036 13.4404 4.5 12.75 4.5C12.0596 4.5 11.5 3.94036 11.5 3.25C11.5 2.55964 12.0596 2 12.75 2Z"
    fill="currentColor"
  />
</template>
